export const districtDefaultValue = {
    id: '',
    name: '',
    province: undefined,
};
